const head = document.querySelectorAll('.library__head li a');
const items = document.querySelectorAll('.library__body a');

// Animate
const animate = (item) => {
  const show = (counter) => {
    setTimeout(() => {
      item[counter].classList.add('view');
      counter++;

      if (counter < item.length) show(counter);
    }, 50);
  };
};

// Hook
const each = (el, callback) => {
  const allElem = document.querySelectorAll(el);
  const allArr = Array.prototype.slice.call(allElem);

  Array.prototype.forEach.call(allArr, (selector) => {
    if (callback) return callback(selector);
  });
};

// Filter links
const filterLinks = (elem) => {
  const el = elem.textContent;

  if (el === 'Todos') {
    each((e) => {
      e.classList.remove('view');
    });
    animate(items);
  } else {
    each((e) => {
      e.classList.remove('view');
    });
  }

  // show animation for current elements
  animate(document.querySelectorAll(`.${el.toLowerCase()}`));
};

// Filter on click
each(head, (elem) => {
  elem.addEventListener('click', (e) => {
    e.preventDefault();
    filterLinks(elem);

    console.log(elem);
  });
});
